import React from 'react'

const FilmList = (props) => {
  return <ul className="filmList-body">{props.children}</ul>
}

export default FilmList
